<template>
  <!-------------------- END - Controles arriba de tabla-------------------->
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Proveedor</th>
          <th style="width: 100px;" scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="det in data" v-bind:key="det.id">
          <td scope="col">
            {{ det.proveedor_obj.codigo }} - {{ det.proveedor_obj.nombre }}
          </td>
          <td scope="col">
            <button
              type="button"
              class="btn btn-sm btn-danger"
              @click="eliminarProveedor(det)"
            >
              Eliminar
            </button>
          </td>
        </tr>
        <tr>
          <td>
            <ProveedoresSelectComponent :current="current" />
          </td>
          <td class="text-right">
            <button
              type="button"
              class="btn btn-sm btn-success"
              @click="agregarProveedor"
            >
              Agregar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductoProveedorService from "@/services/catalogos/ProductoProveedorService";
import ProveedorService from "@/services/catalogos/ProveedorService";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";

export default {
  components: {
    PaginationComponent,
    ProveedoresSelectComponent,
  },
  data() {
    return {
      data: [],
      current: {
        producto: "",
        proveedor: "",
        errors: {
          producto: "",
        },
      },
    };
  },
  props: ["sku"],
  mounted() {
    let self = this;
    self.refreshData({ page:1 });
  },
  methods: {
    agregarProveedor() {
      let self = this;
      if (self.current.proveedor == null || self.current.proveedor == "") {
        alert("proveedor requerida");
        return;
      }

      let params = {
        producto: self.sku,
        proveedor: self.current.proveedor.codigo,
        estatus: true,
      };
      ProductoProveedorService.save(params).then((res) => {
        self.refreshData();
        self.current.producto = "";
        self.current.proveedor = "";
      });
    },
    eliminarProveedor(proveedor) {
      let self = this;
      if (!confirm("¿Desea eliminar la Proveedor?")) {
        return;
      }

      ProductoProveedorService.delete(proveedor.id).then((res) => {
        self.refreshData();
        self.current.producto = "";
        self.current.barra = "";
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({});
    },
    filterData() {
      this.refreshData({});
    },
    clearFilterData() {
      this.refreshData({});
    },
    hide: function() {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      if (params == null){
        params = {}
      }
      let _params = Object.assign(params, {
        producto: self.sku,
        quitar_paginacion: "true",
      });
      ProductoProveedorService.fetch(_params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      /*let self = this;
      self.$router.push({
        name: "cat-centro-costos-editar",
        params: { id: current.id },
      });*/
    },
    showModalEdit() {},
  },
};
</script>
